import axios from 'axios'

// axios.defaults.xsrfHeaderName = 'X-CSRFToken'
// axios.defaults.xsrfCookieName = 'csrftoken'

class Client {
  get (url, params) {
    const command = axios.get(url, {
      params: params,
      withCredentials: true,
    })
    return command
  }

  post (url, data, params) {
    const command = axios.post(url, data, {
      params: params,
      withCredentials: true,
    })
    return command
  }

  put (url, data) {
    const command = axios.put(url, data, { withCredentials: true })
    return command
  }

  delete (url, params) {
    const command = axios.delete(url, {
      params: params,
      withCredentials: true,
    })
    return command
  }
}

export default new Client()
